// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "6a729096" + "." + "e8465895ac07475e" + ".js";
};